import { getSubscriptions } from '@base/api';
import { useAuthStore } from '@fleek-platform/login-button';
import { useQuery } from '@tanstack/react-query';

export const useSubscriptions = () => {
  const { accessToken, projectId } = useAuthStore();
  return useQuery({
    queryKey: ['subscriptions'],
    queryFn: async () => {
      return getSubscriptions(
        {
          accessToken,
          projectId,
        },
        {
          throwOnError: true,
        },
      );
    },
  });
};
